import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./ImageOpt"
const LatestNews = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const PostData = useStaticQuery(graphql`
    query PostQuery {
      allWpPost(limit: 7, sort: { date: DESC }) {
        edges {
          node {
            title
            featuredImage {
              node {
                mediaItemUrl
                altText
              }
            }
            uri
          }
        }
      }
    }
  `)
  const AllPostData = PostData.allWpPost.edges
  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }

  if (module.hideSection === "no") {
    return (
      <section
        className={`${module.background === "no" ? "bg-white-100" : ""} `}
      >
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`news-slider pt-110 lgscreen:pt-30 pb-80 lgscreen:pb-30 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-md pr-0"
          >
            <div className="w-full lgscreen:pr-20">
              {module?.preHeading && (
                <div className="preheading mb-5 lgscreen:mb-15">
                  <motion.div
                    variants={animFade}
                    className="font-ositalic text-16"
                  >
                    {module.preHeading}
                  </motion.div>
                </div>
              )}
              {module?.heading && (
                <motion.h2 variants={animFade}>{module.heading}</motion.h2>
              )}
              {module?.description && (
                <motion.div
                  variants={animFade}
                  className="content pt-5 lgscreen:pt-15"
                >
                  {parse(module.description)}
                </motion.div>
              )}
            </div>
            {AllPostData.length > 0 && (
              <motion.div variants={animFade} className="relative mt-40">
                <Swiper
                  spaceBetween={30}
                  loop={true}
                  slidesPerView={"3.5"}
                  speed={1000}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    clickable: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1.5,
                    },
                    641: {
                      slidesPerView: 3,
                    },
                    1024: {
                      slidesPerView: 3.5,
                    },
                  }}
                  modules={[Autoplay, Navigation]}
                >
                  {AllPostData.map((item, i) => {
                    return (
                      <SwiperSlide key={i}>
                        <Link to={item.node.uri} className="relative group">
                          {item?.node.featuredImage ? (
                            <div className="img relative">
                              <div className="img-overlay absolute top-0 left-0 h-full w-full z-10 bg-[#000000]/0 group-hover:bg-[#000000]/[0.15] transition-all duration-150 ease-out"></div>
                              <ImageOpt
                                imgData={
                                  item.node.featuredImage.node.mediaItemUrl
                                }
                                width={1000}
                                height={1000}
                                imgAlt={item.node.featuredImage.node.altText}
                                imgLoad="lazy"
                              />
                            </div>
                          ) : (
                            <div className="img relative">
                              <div className="img-overlay absolute top-0 left-0 h-full w-full z-10 bg-[#000000]/0 group-hover:bg-[#000000]/[0.15] transition-all duration-150 ease-out"></div>
                              <ImageOpt
                                imgData={
                                  item.blogContent.bannerImage.mediaItemUrl
                                }
                                width={1000}
                                height={1000}
                                imgAlt={item.blogContent.bannerImage.altText}
                                imgLoad="lazy"
                              />
                            </div>
                          )}
                          {item.node?.title && (
                            <h6 className="text-charcoal font-ositalic normal-case mt-15 pr-50 desktop2:pr-25">
                              {item.node.title}
                            </h6>
                          )}
                        </Link>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
                <div className="swiper-arrow arrow-big flex gap-x-5">
                  <button
                    className="absolute right-40 lgscreen:right-20 top-[calc(50%_-_40px)] translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                    onClick={() => handleNextClick(".news-slider .swiper")}
                  >
                    <img
                      src="../images/slider-arrow.svg"
                      width={42}
                      height={42}
                      className="scale-x-[-1]"
                      loading="lazy"
                      alt="Arrow"
                    />
                  </button>
                </div>
              </motion.div>
            )}
            {module?.button && (
              <motion.div
                variants={animFade}
                className="mt-40 lgscreen:mt-20 smscreen:pr-20"
              >
                <Link
                  to={module.button.url}
                  target={module.button.target}
                  className="btn btn-border"
                >
                  {module.button.title}
                </Link>
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default LatestNews
export const PageLatestNewsFragment = graphql`
  fragment PageLatestNewsFragment on WpPage_Pagecontent_PageContent_LatestNews {
    extraId
    extraClass
    hideSection
    background
    preHeading
    heading
    description
    button {
      target
      title
      url
    }
  }
`
